module.exports = __webpack_public_path__ + "static/ticket-number-box-sample-82f87441fb13747aeaf891ad6c418f5b.png";